/**
 * @Author Adnan
 * @since 1-8-21
 * @Description API endpoints for backend
 *
 **/
import { environment } from "../environments/environment";

/** Host from `environment.baseUrl` (scheme + host, no path). */
const apiHost = environment.baseUrl.replace(/\/+$/, '');
/** Admin API base — `api/v1/admin/` is applied here for every endpoint below. */
const baseUrl = `${apiHost}/api/v1/admin/`;
const baseUrlForItem = `${apiHost}/api/v1/`;


export class URLConfig {
  //Auth Module
  public static login = baseUrl + "Admin/admin-login";
  public static forgotPassword = baseUrl + "Admin/forgot-password";
  public static resetPassword = baseUrl + "Admin/admin-reset-password";
  public static sendVerificationEmailAdmin = baseUrl + "Admin/send-verification-email-admin";
  public static adminVerifyEmail = baseUrl + "Admin/admin-verify-email";
  public static refreshToken = baseUrl + "Admin/admin-refresh-token";
  public static changepassword = baseUrl + "Admin/admin-change-password";

  ///Dashboard
  public static getStats = baseUrl + "Adminstats/get-stats";

  //user
  public static getUser = baseUrl + "Manage/users";
  /** GET `Manage/user/{id}` — single user (admin) */
  public static getUserById = baseUrl + "Manage/user/";
  public static getUserSearch = baseUrl + "Adminstats/search-user";
  /** GET `Manage/orders/{auction}` — auction path: `true` | `false` */
  public static getOrderSearch = baseUrl + "Manage/orders";
  public static updateUser = baseUrl + "user/update-user";

  //stores
  public static getStore = baseUrl + "Manage/shops";
  public static getSearchStore = baseUrl + "Adminstats/search-store";
  public static postStoreBlock= baseUrl + "Manage/block-store";
  public static postStoreUnblock= baseUrl + "Manage/unblock-store";
  //products
  /** GET pending approvals — each row includes `auction` (boolean). */
  public static getproducts = baseUrl + "Manage/pending-item-approval";
  public static gettoppicks = baseUrl + "Manage/all-picked";
  public static addtoppicks = baseUrl + "Manage/add-to-picked";
  public static removetoppicks = baseUrl + "Manage/remove-from-picked";

  //rising label
  public static getRisingLabel = baseUrl + "Admin/get-rising-labels";
  public static addRisingLabel = baseUrl + "Admin/add-rising-labels";
  public static removeRisingLabel = baseUrl + "Admin/remove-rising-labels";

  //pending products
  public static getPendingPayment = baseUrl + "Adminstats/get-pending-payments";
  /** GET `Manage/orders/{auction}` — same base as getOrderSearch */
  public static getPendingOrder = baseUrl + "Manage/orders";

  //Hide Item
  public static hideItem = baseUrl + "Items/visible";
  public static ItemUpdate = baseUrl + "Items/item-update";
  /** POST `Manage/approve-item/{itemId}/{auction}` */
  public static approveItem = baseUrl + "Manage/approve-item";
  /** POST `Manage/reject-item/{itemId}/{auction}` */
  public static rejectItem = baseUrl + "Manage/reject-item";
  /** POST `Manage/delist-item/{itemId}/{auction}` */
  public static delistItem = baseUrl + "Manage/delist-item";

  //Shops
  public static shopDetail = baseUrl + "Manage/shop";
  public static shops = baseUrl + "home/all-shops";

  // items get endpoint
  public static itemDetail = baseUrlForItem + "Items/item-detail";
  /** GET `Auction/auction-item-detail?auctionItemId=&ownerId=` */
  public static auctionItemDetail = baseUrlForItem + "Auctions/auction-item-detail";
  public static itemReviews = baseUrlForItem + "Items/item-reviews";
  /** GET paginated store reviews — align query params with backend (e.g. userId, page, pageSize). */
  public static shopReviews = baseUrlForItem + "Shop/shop-reviews";
  /** POST body typically `{ itemId }` — confirm path with API. */
  public static toggleItemLike = baseUrlForItem + "Items/toggle-item-like";

  public static itemOwnerDetail = baseUrl + "Items/item-detail-owner";
  public static editDetail = baseUrl + "Items/edit-item";

  //Delete Item
  public static deleteItem = baseUrl + "Items/delete-item";

  //Review 
  public static getReview = baseUrl + "Adminstats/get-all-comments";
  public static deleteReview = baseUrl + "Adminstats/delete-comment";
  public static approveReview = baseUrl + "Adminstats/approve-comment";

  //payment
  public static paymentRelease = baseUrl + "Adminstats/payment-release";

  //Dashboard 
  public static getDashboardGraphData = baseUrl + "Adminstats/admin-graph-onload";
  public static getDashboardGraphByYearData = baseUrl + "Adminstats/admin-graph-by-year";
  public static getDashboardGraphByYearRangeData = baseUrl + "Adminstats/admin-graph-by-year-range";


  // withdraw requests (admin Accounts)
  public static withdraws = baseUrl + "Accounts/withdraws";
  /** PUT `Accounts/mark-withdraw-cancell/{id}?adminId=` — path spelling matches backend */
  public static markWithdrawCancel = baseUrl + "Accounts/mark-withdraw-cancell/";
  public static markWithdrawInProcess = baseUrl + "Accounts/mark-withdraw-inprocess/";
  /** PUT `Accounts/mark-withdraw-complete/{id}?adminId=` */
  public static markWithdrawComplete = baseUrl + "Accounts/mark-withdraw-complete/";

  // setting (admin app-setting + `?value=` updates — setting component only)
  public static getSetting = baseUrl + "Setting/app-setting";
  public static updateApproveFlow = baseUrl + "Setting/update-approve-flow";
  public static updateMinimumItemPrice = baseUrl + "Setting/minimum-item-price";
  public static updatePlatformCommission = baseUrl + "Setting/platform-commission";
  public static updateShowSpotLight = baseUrl + "Setting/show-spot-light";
  /** GET list · POST create — `Setting/spotlight-packages` */
  public static spotlightPackages = baseUrl + "Setting/spotlight-packages";

  public static items = baseUrl + "Categories/get-catgories";

  // telr requests
  public static getTelrRequests = baseUrl + "Admin/telr-request?";
  public static updateTelrRequest = baseUrl + "Admin/update-telr-request?";
  public static updateTelrRequestId = baseUrl + "Admin/update-telr-id?";

  // support
  public static getsupport = baseUrl + "info/all-info";


  // notification
  public static notification = baseUrl + "Admin/send-fcm";

  // spotlight
  public static spotlight = baseUrl + "Manage/spotlight-items";
  /** POST body optional; itemId as query — align with backend if path differs */
  public static removeSpotlight = baseUrl + "Manage/remove-from-spotlight";

  // support
  public static getUserDetails = baseUrl + "user/get-user";

}
